// =============================================================================
// Imports
// =============================================================================
// Utilities
import { dom } from "../utils";
import Accordion from "../../components/Accordion/index";
import SiteHeader from "../../components/SiteHeader/index";
import Cost from "../../components/Cost/index";
import OpeningHours from "../../components/OpeningHours/index";
import Map from "../../components/Map/index";
import Countdown from "../../components/Countdown/index";
import ContactOverview from "../../components/ContactOverview/index";
import FilterDropdown from "../../components/Inputs/FilterDropdown/index";
import Gallery from "../../components/Gallery/index";
import CookieRow from "../../components/CookieRow/index";
import HeaderMobile from "../../components/SiteHeader/Mobile/index";
import CampaignOverview from "../../components/CampaignOverview/index";
import NewsOverview from "../../components/NewsOverview/index";
import NewsDetail from "../../components/NewsDetail/index";
import SearchSportsCamps from "../../components/SearchSportsCamps/index";
import CookieBanner from "../../components/CookieBanner/index";
import Search from "../../components/Search/index";
import Floorplan from "../../components/Floorplan/index";
import RoutePlanner from "../../components/SportRoutes/Components/RoutePlanner/index";
import ContactBlock from "../../components/ContactBlock/index";
import ClickablePos from "../../components/POS";
import DownloadLink from "../../components/DownloadList";
import FilterTable from "../../components/FilterTable";
import centraFilterButton from "../../components/Button/centraFilterButton";
import centraFilterCheckbox from "../../components/CenterOverviewPage/inputs/Checkbox";
import centraFilterDropdown from "../../components/CenterOverviewPage/inputs/Dropdown";
import initToggleCentraDisplay  from "../../components/CenterOverviewPage/inputs/Toggle";
import ApplicationFrame from "../../components/ApplicationFrame/index";

// Modules
// =============================================================================
// Definition
// =============================================================================

/**
 * Info
 * -----
 * Initialise and export all initialised components to be used on the different
 * component pages and in the final build.
 *
 * Usage: dom.init({ selector: "[.js-[class]]", Module: [name] }),
 */

export default () => [
  // Initialise, if they exist, the modules

  dom.init({ selector: ".js-accordion", Module: Accordion }),
  dom.init({ selector: ".js-site-header", Module: SiteHeader }),
  dom.init({ selector: ".js-cost", Module: Cost }),
  dom.init({ selector: ".js-openinghours", Module: OpeningHours }),
  dom.init({ selector: ".js-map", Module: Map }),
  dom.init({ selector: ".js-countdown", Module: Countdown }),
  dom.init({ selector: ".js-contactoverview", Module: ContactOverview }),
  dom.init({ selector: ".js-filterdropdown", Module: FilterDropdown }),
  dom.init({ selector: ".js-gallery", Module: Gallery }),
  dom.init({ selector: ".js-cookie-row", Module: CookieRow }),
  dom.init({ selector: ".js-header-mobile", Module: HeaderMobile }),
  dom.init({ selector: ".js-campaign-overview", Module: CampaignOverview }),
  dom.init({ selector: ".js-news-overview", Module: NewsOverview }),
  dom.init({ selector: ".js-news-detail", Module: NewsDetail }),
  dom.init({ selector: ".js-search-sports-camps", Module: SearchSportsCamps }),
  dom.init({ selector: ".js-cookie-consent", Module: CookieBanner }),
  dom.init({ selector: ".js-search", Module: Search }),
  dom.init({ selector: ".js-floorplan", Module: Floorplan }),
  dom.initWithDelay({ selector: ".js-routeplanner", Module: RoutePlanner, delay: 500}),
  dom.init({ selector: ".js-contactblock", Module: ContactBlock }),
  dom.init({ selector: ".js-clickable-pos", Module: ClickablePos }),
  dom.init({ selector: ".js-download-link", Module: DownloadLink }),
  dom.init({ selector: ".js-filtertable", Module: FilterTable }),
  dom.init({ selector: ".js-checkbox-centra", Module: centraFilterCheckbox }),
  dom.init({ selector: ".js-select-centra", Module: centraFilterDropdown }),
  dom.init({ selector: ".js-centra-filter-button", Module: centraFilterButton }),
  dom.init({ selector: ".js-toggle-centra", Module: initToggleCentraDisplay }),
  dom.init({ selector: ".applicationframe", Module: ApplicationFrame })
];
